import React, { useCallback } from 'react';
import { navigate } from 'gatsby';
import { FaCheckCircle } from 'react-icons/fa';
import Button from '../../Button';
import { ButtonMobileView, RegisteredSuccessView, StoreInfoBox } from '../styles';
import { useRegister } from '../../../hooks/register';
import { encrypt } from '../../../utils/encryption';
import { appStoreUrl, playStoreUrl, dynamicStoreUrl, ADMIN_URL } from '../../../constants';
import { SignHeadText } from '../../../styles/globalStyled';
import { useModal } from '../../../hooks/modal';
import { stepsKeys } from '../../../pages/register';

const RegisteredSignUp: React.FC = () => {
  const { userData, loading, handleLoading, handleStep } = useRegister();
  const { handleModal } = useModal();

  const redirectToAdmin = useCallback(() => {
    const { documentNumber, password, email } = userData;
    handleLoading(true);
    try {
      if (documentNumber && password) {
        const encryptedLogin = encrypt({ email, password });
        const redirectUrl = `${ADMIN_URL}/home?login=${encodeURIComponent(encryptedLogin || '')}`;
        window.open(redirectUrl, '_self');
      }
    } catch (err) {
      handleLoading(false);
    }
  }, []);

  const redirectToLogin = () => {
    navigate('/');
    handleModal({ isOpen: true, action: 'signin' });
    handleStep(stepsKeys[0]);
  };

  const getUserFistName = useCallback((username) => (username.fullName ? username.fullName.split(' ')[0] : '-'), []);

  return (
    <>
      <RegisteredSuccessView>
        <FaCheckCircle size={60} />
        <SignHeadText>
          <label htmlFor="title">Bem-vindo, {getUserFistName(userData)}!</label>
          <p>
            É muito bom ter você por aqui. A partir de agora você pode utilizar todos os benefícios do aplicativo Allya!
          </p>
        </SignHeadText>
        <Button title="Entrar agora" loading={loading} classType="big fat blue center" onClick={redirectToAdmin} />
        <StoreInfoBox>
          <p>ou baixe nosso aplicativo</p>
          <div className="store-row">
            <div>
              <a href={appStoreUrl} rel="noopener noreferrer" target="_blank">
                <img src={'img/iconappstore.png'} alt="appstore" />
              </a>
              <a href={playStoreUrl} rel="noopener noreferrer" target="_blank">
                <img src={'img/icongoogle.png'} alt="playstore" />
              </a>
            </div>
            <img src={'img/QRcode.png'} alt="qrCode" />
            <p>Escaneie para baixar o app</p>
          </div>
        </StoreInfoBox>
      </RegisteredSuccessView>
      <ButtonMobileView href={dynamicStoreUrl} rel="noopener noreferrer" target="_blank">
        <Button title="Baixar nosso aplicativo agora" classType="big fat center" />
      </ButtonMobileView>
    </>
  );
};

export default RegisteredSignUp;
